import commonHelper from '@/app/utility/common.helper.utility';
import summaryData from './summaryData';
export default {
  name: 'assetStatus',
  props:['dashData','locId','locAccessFlag'],
  components:{
    summaryData
},
  watch: {
    currentPage: function() {
        this.getDashboardDetails();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getDashboardDetails();
    },
  },
  data() {
    return {
      totalRows: null,
      currentPage: 1,
      loader: false,
      responseMsg: '',
      isSuccess: false,
      showAlert: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOptionSelectedInvoice(),
      statusHistoryData:[
      ],
      statusHistoryFields:[
        {
          key:'serial_no',
          label: 'S.No.'
        },
        {
          key:'po_number',
          label: 'PO Number'
        },
        {
          key:'org_name',
          label:'Cost Center'
        },
        {
          key:'oracle_id',
        },
        {
          key:'model_number',
          label: 'Model No.'
        },
        {
          key:'le_name',
          label:"Legal Entity"
        },
        {
          key:'item_code'
        },
        {
          key:'installation_date'
        },
        {
          key:'hsn_sac_code',
          label:"HSN/SAC Code"
        },
        {
          key:'exp_date',
          label:"Expiry Date"
        },
        {
          key:'doc_num',
          label:"Document No."
        },
        {
          key:'description'
        },
        {
          key:'department_user_responsible',
          label:"Department"
        },
        {
          key:'capacity_unit'
        },
        {
          key:'calib_date',
          label:"Calibration Date"
        },
        {
          key:'book_type_code',
          label:"Book Type"
        },
        {
          key:'asset_status',
        },
        {
          key: 'actual_cost'
        },
        {
          key: 'accuracy_resolution'
        }
      ],
      countData: null,
      additionalModal: false,
      rowData: null
    };
  },
  mounted() {
    this.getDashboardDetails()
    if(this.dashData){
        this.countData = this.dashData.count;
    }
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          //   this.showHideAddFaLocationModal(true);
        } else if (actionName === 'edit' || actionName === 'update' && (!this.showAssetDetailsModalFlag || !this.showDashDetailFlag)) {
          this.editMode = true;
        }
        else if (
          actionName === 'download' && !this.showAssetDetailsModalFlag
        ) {
            this.loader = true;
            const downloadpayload = { ...this.payload };
            downloadpayload.queryParams._limit = this.totalRows;
            this.downloadExcel.downloadData(
              downloadpayload,
              'assets/getDashboardAssetStatusDetails',
              'fa-getAssetDetails',
              () => (this.loader = false),
            );
        }
      }
    });
  },
  methods: {
  getDashboardDetails() {
    this.payload = {
      _page: this.currentPage - 1,
      _limit: this.perPage,
      hr_loc: this.locId,
      cap_unit: this.dashData.count,
    };
    this.loader = true;
    this.$store
      .dispatch('weighMachine/getDashboardDetails', this.payload)
      .then(resp => {
        this.loader = false;
        if (resp.status === 200) {
          this.statusHistoryData = resp.data.data.page;
          this.totalRows = resp.data.data.total_elements;
        }
      })
      .catch(() => {
        this.loader = false;
      });
  },
  rowSelected(item) {
    this.showHideAdditionalModal(true);
    this.rowData = item;
  },
  showHideAdditionalModal(flag) {
    this.additionalModal = flag;
  },
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
